import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Search, Bell, Globe, ChevronDown, LayoutDashboard, Users, CheckSquare, Calendar, BarChart2, FileText, MessageSquare, Settings, LogOut } from 'lucide-react';
import { useAuth } from './auth/AuthContext';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const {
    logout
  } = useAuth();
  return <div className="flex flex-col min-h-screen bg-gray-50" dir="rtl" data-id="element-1205">
      {/* Top Navigation Bar */}
      <header className="bg-white border-b border-gray-200" data-id="element-1206">
        <div className="flex items-center justify-between px-4 py-2" data-id="element-1207">
          {/* Logo */}
          <div className="flex items-center" data-id="element-1208">
            <img src="https://dwaami.sbaapp.net/images/dwaami.png" alt="شعار" className="h-10 w-auto" data-id="element-1209" />
          </div>
          {/* Navigation Icons */}
          <div className="flex items-center space-x-6" data-id="element-1210">
            <Link to="/" className={`p-2 ${location.pathname === '/' ? 'text-orange-500' : 'text-gray-500'}`} data-id="element-1211">
              <LayoutDashboard size={20} data-id="element-1212" />
            </Link>
            <Link to="/committees" className={`p-2 ${location.pathname === '/committees' ? 'text-orange-500' : 'text-gray-500'}`} data-id="element-1213">
              <Users size={20} data-id="element-1214" />
            </Link>
            <Link to="/tasks" className={`p-2 ${location.pathname === '/tasks' ? 'text-orange-500' : 'text-gray-500'}`} data-id="element-1215">
              <CheckSquare size={20} data-id="element-1216" />
            </Link>
            <Link to="/meetings" className={`p-2 ${location.pathname === '/meetings' ? 'text-orange-500' : 'text-gray-500'}`} data-id="element-1217">
              <Calendar size={20} data-id="element-1218" />
            </Link>
            <Link to="/reports" className={`p-2 ${location.pathname === '/reports' ? 'text-orange-500' : 'text-gray-500'}`} data-id="element-1219">
              <BarChart2 size={20} data-id="element-1220" />
            </Link>
          </div>
          {/* Search Bar */}
          <div className="flex-1 max-w-xl mx-6" data-id="element-1221">
            <div className="relative" data-id="element-1222">
              <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-1223" />
              <input type="text" placeholder="ابحث هنا..." className="w-full pr-10 pl-4 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-1224" />
              <div className="absolute left-3 top-1/2 transform -translate-y-1/2 flex items-center text-gray-400 text-sm" data-id="element-1225">
                <span className="border border-gray-300 rounded px-1 ml-1" data-id="element-1226">
                  ⌘
                </span>
                <span className="border border-gray-300 rounded px-1" data-id="element-1227">/</span>
              </div>
            </div>
          </div>
          {/* User Profile */}
          <div className="flex items-center" data-id="element-1228">
            <div className="flex items-center ml-4" data-id="element-1229">
              <div className="flex items-center" data-id="element-1230">
                <Globe size={20} className="text-gray-500 ml-1" data-id="element-1231" />
                <span className="text-gray-700 font-medium" data-id="element-1232">العربية</span>
                <ChevronDown size={16} className="text-gray-500 mr-1" data-id="element-1233" />
              </div>
            </div>
            <div className="flex items-center" data-id="element-1234">
              <div className="h-10 w-10 bg-gray-700 rounded-full flex items-center justify-center text-white font-bold" data-id="element-1235">
                أ
              </div>
              <div className="mr-2" data-id="element-1236">
                <div className="flex items-center" data-id="element-1237">
                  <span className="text-gray-800 font-medium" data-id="element-1238">المشرف</span>
                  <div className="relative group" data-id="element-1239">
                    <ChevronDown size={16} className="text-gray-500 mr-1 cursor-pointer" data-id="element-1240" />
                    <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 hidden group-hover:block" data-id="element-1241">
                      <Link to="/settings" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-1242">
                        الإعدادات
                      </Link>
                      <button onClick={logout} className="block w-full text-right px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-1243">
                        <LogOut size={16} className="inline ml-2" data-id="element-1244" />
                        تسجيل الخروج
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* Welcome Banner */}
      <div className="bg-gray-800 text-white p-6 relative overflow-hidden" data-id="element-1245">
        <div className="relative z-10" data-id="element-1246">
          <h1 className="text-2xl font-bold" data-id="element-1247">صباح الخير، المشرف</h1>
          <p className="text-gray-300" data-id="element-1248">مرحباً بك في منصة إدارة اللجان</p>
        </div>
        <div className="absolute top-0 right-0 left-0 bottom-0 opacity-20" data-id="element-1249">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="absolute bottom-0" data-id="element-1250">
            <path fill="#FF9800" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,106.7C960,117,1056,139,1152,133.3C1248,128,1344,96,1392,80L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" data-id="element-1251"></path>
          </svg>
        </div>
      </div>
      {/* Main Content */}
      <main className="flex-1 p-6" data-id="element-1252">{children}</main>
    </div>;
}